import fetch from "../components/optionsFetch";
import * as React from "react";
import Notifications from '../components/Notifications';
import AdvancedSearchNotice from '../components/AdvancedSearchNotice';
import DataGrid from "../components/DataGrid";
import GetColumnDefs from "../components/ColumnDefs";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TextBox } from "@progress/kendo-react-inputs";
import configData from "../config.json";
import { GetSession, GetToken } from "../components/Session";
import { GetPermissions } from '../components/Options';
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { useNavigate } from "react-router-dom";
import { filterBy } from "@progress/kendo-data-query";
import { getMultiSelectTreeValue } from "@progress/kendo-react-dropdowns";
import { processMultiSelectTreeData, expandedState } from "../components/multiselecttree-data-operations";
import { MultiSelectTreeEditor } from "../components/MultiSelectTreeEditor";

const Products = () => {
    const [lookupParams, setLookupParams] = React.useState("");
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState();
    const [source, setSource] = React.useState();
    const [destinations, setDestinations] = React.useState([]);
    const [directions, setDirections] = React.useState([]);
    const [direction, setDirection] = React.useState();
    const [stockLevel, setStockLevel] = React.useState(0);
    const [expanded, setExpanded] = React.useState(false);
    const [filtersApplied, setFiltersApplied] = React.useState(() => Boolean(localStorage.getItem("ProductSearch")));
    const statii = ["All", "Active", "Inactive"];
    const [status, setStatus] = React.useState("Active");
    const ready = React.useRef(false);
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    if (localStorage.getItem("userid") === null) navigate("/logout");
    if (permissions && !permissions.CanView) navigate("/error401");
    const options = React.useRef();
    let ps = localStorage.getItem("ProductSearch");
    const showSites = GetSession().SiteID === 1;


    const [layout, setLayout] = React.useState([
        { "field": "searchAdvanced", "label": "Advanced Search", "isVisible": true },
        { "field": "searchSite", "label": "Site", "isVisible": true },
        { "field": "searchSource", "label": "Source", "isVisible": true },
        { "field": "searchDestination", "label": "Destination", "isVisible": true },
        { "field": "searchDirection", "label": "Direction", "isVisible": true },
        { "field": "searchStatus", "label": "Status", "isVisible": true },
        { "field": "stockLevelBelow", "label": "Show Stock Level Below", "isVisible": true }
    ]);

    const subTotals = [
        { field: 'inLocalDiscount', aggregate: 'average' },
        { field: 'outLocalDiscount', aggregate: 'average' },
        { field: 'minLocalDiscount', aggregate: 'average' },
        { field: 'inVisitStandard', aggregate: 'average' },
        { field: 'outVisitStandard', aggregate: 'average' },
        { field: 'ePALevy', aggregate: 'average' },
        { field: 'minePALevy', aggregate: 'average' }
    ];

    const GetField = (f) => {
        return layout.find(obj => { return obj.field === f });
    }

    const sourceChanged = (event) => {
        setSource(event.target.value);
    };
    const siteChanged = (event) => {
        setSite(event.target.value);
    };
    const directionChanged = (event) => {
        setDirection(event.target.value);
    };
    const stockLevelChanged = (event) => {
        setStockLevel(event.target.value);
    }
    const DoSearch = () => {
        if (ready.current) {
            var prodParam = {
                Source: GetIds(sourcesValue),
                Destination: GetIds(destinationsValue),
                Site: site.id,
                Direction: direction,
                StockLevel: parseInt(stockLevel),
                Status: status
            };
            setLookupParams(encodeURI(JSON.stringify(prodParam)));
            localStorage.setItem("ProductSearch", JSON.stringify(prodParam));
            setFiltersApplied(true);
        }
    };
    const ClearSearch = () => {
        setFiltersApplied(false);
        if (ready.current) {
            ClearParams();
            var jobParam = {
                Source: null,
                Destination: null,
                Site: "0",
                Direction: "All",
                StockLevel: 0,
                Status: "Active"
            };
            setLookupParams(encodeURI(JSON.stringify(jobParam)));
            localStorage.removeItem("ProductSearch");
        }
    };
    const ClearParams = () => {
        setSourcesValue([]);
        setDestinationsValue([]);
        setSite({ id: "0", name: "All" });
        setDirection("All");
        setStockLevel(0);
        setStatus("Active");
    };

    const UpdateSavedParams = () => {
        if (ps === undefined) return;
        let def = JSON.parse(ps);
        setDirection(def.Direction);
        let src = GetSelected(options.current.sources, def.Source);
        if (src !== undefined && src[0] === undefined) src = [];
        setSourcesValue(src);
        let dst = GetSelected(options.current.destinations, def.Destination);
        if (dst !== undefined && dst[0] === undefined) dst = [];
        setDestinationsValue(dst);
        let st = options.current.sites.find(obj => { return obj.id === def.Site });
        if (st === undefined) st = { id: "0", name: "All" }
        setSite(st);
        setStockLevel(def.StockLevel);
        setStatus(def.Status);
        var jobParam = {
            Source: def.Source,
            Destination: def.Destination,
            Site: def.Site,
            Direction: def.Direction,
            StockLevel: def.StockLevel,
            Status: def.Status
        };
        setLookupParams(encodeURI(JSON.stringify(jobParam)));
    }

    const GetSelected = (c, d) => {
        let r = [];
        if (d === undefined || d === null || d === "0") return r;
        let sp = d.split(';');
        sp.forEach(s => {
            let f = c.find(obj => { return obj.id === s });
            if (f !== undefined) r.push({ id: f.id, text: f.name });
        });
        return r;
    }

    const GetIds = (d) => {
        if (d === null || d.length === undefined || d.length === 0) return "0";
        let r = "";
        d.map(x => {
            r += (r.length > 0 ? ";" : "") + x.id;
        });
        return r;
    }

    React.useEffect(() => {
        GetColumnDefs("products", setColumns, setErrorMessage);
        GetPermissions(["ViewProduct", "NewProduct", "EditProduct", "DeleteProduct", "ReportProduct"], setPermissions)
        let baseUrl = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'Products'";
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        fetch(baseUrl, init).then(response => response.json()).then(d => {
            if (GetSession().IsMobile) {
                let data = [];
                for (let i = 0; i < d.length; i++) {
                    data.push({ field: d[i].field, label: d[i].label, type: d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile });
                }
                setLayout(data);
            } else {
                setLayout(d);
            }
        });
        baseUrl = configData.SERVER_URL + "apiv7/options";
        fetch(baseUrl, init)
            .then((response) => response.json())
            .then((d) => {
                options.current = d;
                ConfigureDestinations(d.destinations);
                ConfigureSources(d.sources);
                setSites(CreateList(d.sites));
                setDirections(d.directions);
                ready.current = true;
                if (ps !== undefined && ps !== "" && ps !== null) {
                    setTimeout(() => { UpdateSavedParams() }, 100);
                } else {
                    ClearParams();
                }
            });
    }, []);

    const CreateList = (d) => {
        var x = [{ id: "0", name: "All" }];
        return x.concat(d);
    };

    const RowStyle = (p) => {
        let bg = { backgroundColor: "white" };
        if (p.dataItem.stockLevel < p.dataItem.minimumStockLevel) {
            bg = { backgroundColor: "rgb(243, 23, 0, 0.5)" };
        } else {
            if (p.dataItem.stockLevel < p.dataItem.minimumStockLevel * 1.2) bg = { backgroundColor: "rgb(255, 255, 127, 1)" };
        }
        return bg;
    }

    const dataItemKey = "id";
    const checkField = "checkField";
    const checkIndeterminateField = "checkIndeterminateField";
    const subItemsField = "items";
    const expandField = "expanded";
    const textField = "text";
    const fields = { dataItemKey, checkField, checkIndeterminateField, expandField, subItemsField };

    const GetConfigData = (act) => {
        let sl = [];
        let selected = [];
        for (let i = 0; i < act.length; i++) {
            let entry = { text: act[i].name, id: act[i].id };
            sl.push(entry);
            selected.push(entry);
        }
        let active = { id: 0, text: 'All', items: sl };
        return { active: active, selected: selected };
    }

    // state data for source multi-select tree   
    const [sourcesData, setSourcesData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [sourcesValue, setSourcesValue] = React.useState([]);
    const [sourceExpanded, setSourceExpanded] = React.useState([]);
    const onSourcesChange = (event) => {
        setSourcesValue(getMultiSelectTreeValue(sourcesData, { ...fields, ...event, value: sourcesValue, }));
    }
    const onsourcesExpandChange = React.useCallback((event) => setSourceExpanded(expandedState(event.item, dataItemKey, sourceExpanded)), [sourceExpanded]);
    const sourcesTreeData = React.useMemo(() =>
        processMultiSelectTreeData(sourcesData, { expanded: sourceExpanded, value: sourcesValue, ...fields }), [sourcesData, sourceExpanded, sourcesValue]
    );
    const ConfigureSources = (act) => {
        let x = GetConfigData(act);
        setSourcesData([x.active]);
        return [];
    }
    const SourceChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setSourcesValue(v);
    };

    // state data for destination multi-select tree   
    const [destinationsData, setDestinationsData] = React.useState([{ id: 0, text: "All", items: [] }]);
    const [destinationsValue, setDestinationsValue] = React.useState([]);
    const [destinationExpanded, setDestinationExpanded] = React.useState([]);
    const onDestinationsChange = (event) => {
        setDestinationsValue(getMultiSelectTreeValue(destinationsData, { ...fields, ...event, value: destinationsValue, }));
    }
    const ondestinationsExpandChange = React.useCallback((event) => setDestinationExpanded(expandedState(event.item, dataItemKey, destinationExpanded)), [destinationExpanded]);
    const destinationsTreeData = React.useMemo(() =>
        processMultiSelectTreeData(destinationsData, { expanded: destinationExpanded, value: destinationsValue, ...fields }), [destinationsData, destinationExpanded, destinationsValue]
    );
    const ConfigureDestinations = (act) => {
        let x = GetConfigData(act);
        setDestinationsData([x.active]);
        return [];
    }
    const DestinationChanged = (event) => {
        let v = null;
        if (event.value !== null) v = event.value.filter((n) => { return n.id !== 0 });
        setDestinationsValue(v);
    };

    return (
        <div>
            <Notifications errorMessage={errorMessage} />
            {GetField("searchAdvanced")["isVisible"] && <ExpansionPanel
                className="wm-advanced-search wm-advanced-search--kendo"
                title={GetField("searchAdvanced")["label"]}
                subtitle={filtersApplied ? <AdvancedSearchNotice active={filtersApplied} /> : null}
                expandIcon="fa fa-plus"
                collapseIcon="fa fa-minus"
                expanded={expanded}
                onAction={(e) => setExpanded(!e.expanded)}
            >
                <Reveal className="revealz">
                    {expanded && (
                        <ExpansionPanelContent>
                            <div className="row" style={{ padding: "5px 10px" }}>
                                {showSites && GetField("searchSite")["isVisible"] && <div className="col-md-3">
                                    <label className="control-label">{GetField("searchSite")["label"]}</label>
                                    <DropDownList
                                        id="Site"
                                        data={sites}
                                        value={site}
                                        textField="name"
                                        dataItemKey="id"
                                        onChange={siteChanged}
                                        defaultItem={{ id: "", name: "Select site" }}
                                    />
                                </div>}
                                {GetField("searchSource")["isVisible"] && <div className="col-md-3 MSTree">
                                    <label className="control-label">{GetField("searchSource")["label"]}</label>
                                    <MultiSelectTreeEditor name={"Source"} data={sourcesTreeData} value={sourcesValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={SourceChanged} textField="name" dataItemKey="id" placeholder="Select source" />
                                </div>}
                                {GetField("searchDestination")["isVisible"] && <div className="col-md-3 MSTree">
                                    <label className="control-label">{GetField("searchDestination")["label"]}</label>
                                    <MultiSelectTreeEditor name={"destination"} data={destinationsTreeData} value={destinationsValue} dataItemKey={dataItemKey} checkField={checkField} size="large" onChange={DestinationChanged} textField="name" dataItemKey="id" placeholder="Select destination" />
                                </div>}
                                {GetField("searchDirection")["isVisible"] && <div className="col-md-3">
                                    <label className="control-label">{GetField("searchDirection")["label"]}</label>
                                    <DropDownList
                                        id="Direction"
                                        data={directions}
                                        value={direction}
                                        onChange={directionChanged}
                                        defaultItem="Select direction"
                                    />
                                </div>}
                            </div>
                            <div className="row" style={{ padding: "10px" }}>
                                {GetField("stockLevelBelow")["isVisible"] && <div className="col-md-3">
                                    <label className="control-label">{GetField("stockLevelBelow")["label"]}</label>
                                    <TextBox id="StockLevelBelow" type="number" value={stockLevel} onChange={stockLevelChanged} placeholder="Enter stock level" />
                                </div>}
                                {GetField("searchStatus")["isVisible"] && <div className="col-md-3">
                                    <label className="control-label">{GetField("searchStatus")["label"]}</label>
                                    <DropDownList
                                        id="Status"
                                        data={statii}
                                        value={status}
                                        onChange={e => setStatus(e.value)}
                                        defaultItem="Select status"
                                    />
                                </div>}
                            </div>
                            <div className="row" style={{ padding: "10px" }}>
                                <div className="col-md-5"></div>
                                <div className="col-md-3">
                                    <Button onClick={DoSearch} themeColor="primary" icon="search">
                                        Search
                                    </Button>{" "}
                                    <Button onClick={ClearSearch} icon="reset">
                                        Clear
                                    </Button>
                                </div>
                            </div>
                        </ExpansionPanelContent>
                    )}
                </Reveal>
            </ExpansionPanel>}
            {columns && permissions && <DataGrid
                dataSource="apiv7/products"
                params={lookupParams}
                dataFilter="productType eq 'W'"
                extraParam="/W"
                columns={columns}
                permissions={permissions}
                keyField="productId"
                rowStyle={RowStyle}
                subTotals={subTotals}
            />}
        </div>
    );
};

export default Products;



